import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PopupService } from '../../../../shared/modal/popup.service';
import { MultiTraitQueryContext } from '../../../multi-trait-query-context';
import { MultiTraitQueryService } from '../../../multi-trait-query.service';
import { AlertService } from '../../../../shared/alert/alert.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpResponse } from '@angular/common/http';
import { finalize } from 'rxjs/internal/operators/finalize';
import { TraitFilterRequest, TraitObservation, } from '../../../trait.reference.model';
import { TranslateService } from '@ngx-translate/core';
import { GermplasmDetailsUrlService } from '../../../../shared/germplasm/service/germplasm-details.url.service';
import { VIEW_NAMES_PERMISSIONS } from '../../../../shared/auth/permissions';
import { SubscriptionsManager } from '../../../../shared/util/subscriptions-manager';

@Component({
    selector: 'jhi-trait-observation',
    templateUrl: './trait-observation.component.html'
})
export class TraitObservationComponent implements OnInit {

    subscriptionManager = new SubscriptionsManager();

    titleTable: string;
    title: string;
    traitId: number;
    totalItems: number;
    previousPage: any;

    VIEW_NAMES_PERMISSIONS = [...VIEW_NAMES_PERMISSIONS];
    isLoading: boolean;
    itemsPerPage: number = 20;
    page: number;
    predicate: any;
    reverse: boolean;
    traitObs: TraitObservation[];
    locationHeader: string[];

    constructor(private activatedRoute: ActivatedRoute,
                private queryContext: MultiTraitQueryContext,
                private multiTraitQueryService: MultiTraitQueryService,
                private alertService: AlertService,
                private modal: NgbActiveModal,
                protected germplasmDetailsUrlService: GermplasmDetailsUrlService,
                private router: Router,
    ) {
        this.locationHeader = [];
    }

    getSort() {
        if (!this.predicate) {
            return '';
        }
        return [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    }

    ngOnInit(): void {
        this.page = 1;
        this.previousPage = 1;
        this.totalItems = 0;
        this.traitObs = [];
        this.loadLocationHeader();
        this.loadObservations();
    }

    loadObservations() {
        this.isLoading = true;
        const traitFilter = new TraitFilterRequest(this.queryContext.getTraitFilter().environmentIds, [this.traitId]);
        this.subscriptionManager.add = this.multiTraitQueryService.getTraitObservation(traitFilter, {
            page: this.page - 1,
            size: this.itemsPerPage,
            sort: this.getSort()
        }).pipe(finalize(() => {
            this.isLoading = false;
        })).subscribe(
            (res: HttpResponse<TraitObservation[]>) => this.onSuccess(res.body, res.headers)
        );
    }

    dismiss() {
        this.modal.dismiss();
    }

    transition() {
        this.router.navigate([], {
            queryParamsHandling: 'merge',
            queryParams: {
                page: this.page,
                size: this.itemsPerPage,
                sort: this.getSort()
            }, relativeTo: this.activatedRoute
        });
        this.loadObservations();
    }

    trackId(index: number, item: any) {
        return item.id;
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.transition();
        }
    }

    resetTable() {
        this.page = 1;
        this.previousPage = 1;
        this.loadObservations();
    }

    colspan() {
        return 4 + this.locationHeader.length;
    }

    calculateObsNumber(index: number) {
        return index + 1 + (this.page - 1) * this.itemsPerPage;
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    private onSuccess(data: TraitObservation[], headers) {
        this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
        this.traitObs = data;
    }

    private loadLocationHeader() {
        this.isLoading = true;
        const traitFilter = new TraitFilterRequest(this.queryContext.getTraitFilter().environmentIds, [this.traitId]);
        this.subscriptionManager.add = this.multiTraitQueryService.getTraitTypeLocations(traitFilter).pipe(finalize(() => {
            this.isLoading = false;
        })).subscribe(
            (res: HttpResponse<string[]>) => this.locationHeader = res.body
        );
    }
}

@Component({
    selector: 'jhi-trait-observation-popup',
    template: ''
})
export class TraitObservationPopupComponent implements OnInit {
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private popupService: PopupService,
        private translateService: TranslateService
    ) {
    }

    ngOnDestroy(): void {
        if (this.routeSub) {
            this.routeSub.unsubscribe();
        }
    }

    ngOnInit(): void {
        const traitId = Number(this.route.snapshot.paramMap.get('traitId'));
        const traitName = this.route.snapshot.queryParamMap.get('name');
        const traitType = this.route.snapshot.queryParamMap.get('type');
        const modal = this.popupService.open(TraitObservationComponent as Component, {
            modalDialogClass: 'modal-xl',
            backdrop: 'static'
        });
        modal.then((modalRef) => {
            modalRef.componentInstance.traitId = traitId;
            modalRef.componentInstance.title = this.translateService.instant('multi-trait-query.panel.setup.the.trait.filter.observation.title', { param: traitType });
            modalRef.componentInstance.titleTable = this.translateService.instant('multi-trait-query.panel.setup.the.trait.filter.observation.title.table', { param: traitName });

        });
    }

}
